import withSuspense from "../../../../hocs/withSuspense";
import { SettingsPageSkeleton, SettingsError } from "../../components";
import PaymentMethodPage from "./PaymentMethodPage";

export const PaymentMethodPageWithSuspense = withSuspense(PaymentMethodPage, {
  FallbackComponent: SettingsError,
  loading: (
    <SettingsPageSkeleton rows={2} testId="payment-method-skeleton" />
  ),
});
